<template>
  <div
    class="tw-bg-aside-500 tw-text-white tw-py-2 tw-px-4 tw-flex tw-align-center tw-justify-between tw-text-white dark:tw-text-dorian-gray-500 tw-ml-[50px] lg:tw-ml-0"
  >
    <div class="tw-flex tw-gap-2 tw-items-center">
      <t-upper-nav-badge />
      <t-breadcrumbs />
    </div>
    <div class="tw-flex tw-gap-4">
      <t-upper-nav-profile-settings />
      <t-upper-nav-display-mode />
      <a
        target="_blank"
        class="tw-block hover:tw-text-secondary-500"
        href="https://support.titanhq.com/en/69450-welcome-to-the-titanhq-platform-.html"
        data-test-id="upper-nav-help-button"
        v-tippy="{
          content: $t('tooltip-help'),
          placement: 'bottom',
        }"
        @click="onHelpButtonClick"
      >
        <cl-icon-tabler-help />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import TBreadcrumbs from "@/components/TBreadcrumbs/TBreadcrumbs.vue";
import TUpperNavBadge from "./TUpperNavBadge.vue";
import TUpperNavDisplayMode from "./TUpperNavDisplayMode.vue";
import TUpperNavProfileSettings from "./TUpperNavProfileSettings.vue";
import { matomoTrackEvent } from "@/utils/matomo";

const onHelpButtonClick = () => {
  matomoTrackEvent({
    category: "Upper navigation",
    action: "help button clicked",
    name: "",
  });
};
</script>
